import classNames from "classnames";
import React from "react";
import { useMediaQuery } from "../../../../hooks";
import { Spacer } from "../../../../offering/spacer";
import { Divider } from "../../../components";
import styles from "./offering_intro.module.css";

interface OfferingIntroProps {
  title: string;
  htmlDescription?: string;
  imageSrc?: string;
}

export function OfferingIntro(props: OfferingIntroProps) {
  const { title, htmlDescription, imageSrc } = props;
  const mq = useMediaQuery();

  return (
    <>
      <div
        className={classNames(
          "d-flex align-items-start justify-content-between",
          {
            "mt-5": mq.device === "desktop",
            "flex-column": mq.device === "mobile",
            "mt-3": mq.device === "mobile",
            [styles.introContainer]: mq.device === "mobile",
          }
        )}
        data-testid="offering-intro"
      >
        <div className={styles.header}>
          <div className="offering-intro__title">
            <h1 className="m-0 me-3">{title}</h1>
          </div>
          {htmlDescription && (
            <>
              <Spacer size={16} />
              <div
                className="offering-intro__description"
                dangerouslySetInnerHTML={{
                  __html: htmlDescription,
                }}
              />
            </>
          )}
        </div>
        <img
          src={imageSrc}
          alt="category"
          style={{
            objectFit: "cover",
            width: "100%",
            maxWidth: "620px",
          }}
        />
      </div>
      <Divider />
    </>
  );
}

export function CategoryOfferingIntro(props: OfferingIntroProps) {
  const { title, htmlDescription, imageSrc } = props;
  const mq = useMediaQuery();

  return (
    <>
      <div
        className={classNames(
          "d-flex align-items-center justify-content-between",
          {
            "flex-column": mq.device === "mobile",
            [styles.introContainer]: mq.device === "mobile",
          },
          mq.device === "mobile" ? "mt-3" : "mt-5"
        )}
        data-testid="offering-intro"
      >
        <div className={styles.header}>
          <div className="offering-intro__title">
            <h1 className="m-0 me-3">{title}</h1>
          </div>
          {htmlDescription && (
            <>
              <Spacer size={16} />
              <div
                className="offering-intro__description"
                dangerouslySetInnerHTML={{
                  __html: htmlDescription,
                }}
              />
            </>
          )}
        </div>
        <img
          src={imageSrc}
          alt="category"
          style={{
            objectFit: "cover",
            width: "100%",
            maxWidth: "620px",
          }}
        />
      </div>
      <Divider />
    </>
  );
}
